// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 512 512%27%3E%3Cpath fill=%27none%27 stroke=%27%23616161%27 stroke-width=%2748%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 d=%27M112 184l144 144 144-144%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * mRehab web design system.
 * Imported once from app.tsx. Page modules hold layout only.
 */

:root {
  /* Type */
  --font: 'Open Sans', -apple-system, 'Segoe UI', Roboto, sans-serif;

  /* Spacing (4px base) */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 10px;
  --space-4: 14px;
  --space-5: 18px;
  --space-6: 20px;
  --space-8: 28px;
  --space-12: 36px;
  --space-16: 48px;
  --gutter: 20px;
  --container: 1160px;

  /* Radius */
  --radius-xs: 3px;
  --radius-sm: 6px;
  --radius-input: 8px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 18px;
  --radius-full: 9999px;

  /* Elevation */
  --shadow-xs: 0 1px 1px rgba(40, 26, 34, 0.04);
  --shadow-sm:
    0 1px 1px rgba(40, 26, 34, 0.04),
    0 2px 6px rgba(40, 26, 34, 0.05);
  --shadow-md:
    0 1px 2px rgba(40, 26, 34, 0.05),
    0 6px 18px rgba(40, 26, 34, 0.08);
  --shadow-lg:
    0 2px 4px rgba(40, 26, 34, 0.05),
    0 16px 40px rgba(40, 26, 34, 0.11);
  --shadow-brand: 0 1px 2px rgba(122, 24, 71, 0.2);

  /* Motion */
  --dur-fast: 160ms;
  --dur-med: 260ms;
  --ease-standard: cubic-bezier(0.2, 0, 0, 1);
  /* Legacy names used by older modules */
  --motion-ease-standard: var(--ease-standard);
  --motion-fast: var(--dur-fast);
  --motion-medium: var(--dur-med);
  --motion-slow: var(--dur-med);

  /* Legacy shell tokens */
  --site-paper: var(--bg);
  --site-paper-2: var(--bg);
  --site-ink: var(--text-primary);
  --site-radius-lg: var(--radius-lg);
  --site-shadow: var(--shadow-sm);
}

/* Base */
html {
  /* 15px base: every rem-sized type and gap in the app tightens with it. */
  font-size: 93.75%;
  -webkit-text-size-adjust: 100%;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--font);
  font-size: 1rem;
  line-height: 1.55;
  color: var(--text-primary);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

#root {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  color: var(--text-primary);
  font-family: var(--font);
  text-wrap: balance;
}

h1 {
  font-size: clamp(1.5rem, 1.24rem + 0.8vw, 1.9rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
}

h2 {
  font-size: clamp(1.1rem, 1.02rem + 0.32vw, 1.28rem);
  font-weight: 600;
  line-height: 1.28;
  letter-spacing: -0.014em;
}

h3 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: -0.008em;
}

p {
  margin: 0;
  text-wrap: pretty;
}

img,
video,
iframe {
  max-width: 100%;
}

button,
input,
select,
textarea {
  font-family: inherit;
}

:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

::selection {
  background: var(--surface-selected);
}

.ui-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Skip link */
.ui-skip-link {
  position: absolute;
  top: -100px;
  left: var(--gutter);
  z-index: 1000;
  padding: 10px 16px;
  border-radius: var(--radius-md);
  background: var(--bg);
  color: var(--primary);
  font-weight: 700;
  text-decoration: none;
  box-shadow: var(--shadow-brand);
}

.ui-skip-link:focus-visible {
  top: 12px;
}

/* Page + column */
.ui-page,
.site-page-bg {
  flex: 1 1;
  background: var(--bg);
  padding: var(--space-4) 0 var(--space-12);
}

.ui-container,
.site-main {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 var(--gutter);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

@media (prefers-reduced-motion: no-preference) {
  .ui-container,
  .site-main,
  .site-reveal {
    animation: ui-fade-in var(--dur-med) var(--ease-standard) both;
  }
}

@keyframes ui-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ui-page-header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-1) 0 0;
}

.ui-page-header h1,
.site-page-title {
  margin: 0;
}

.ui-page-header p,
.site-page-lead {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 62ch;
}

.ui-page-header p a,
.site-page-lead a {
  color: var(--link);
  font-weight: 600;
}

/* Breadcrumb */
.ui-breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.ui-breadcrumb a {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 600;
  padding: 6px 0;
}

.ui-breadcrumb a:hover {
  color: var(--primary);
}

/* Inline text links inside body copy */
.ui-link {
  color: var(--link);
  font-weight: 600;
  text-decoration: underline;
  text-decoration-thickness: 0.09em;
  text-underline-offset: 0.16em;
}

.ui-link:hover {
  color: var(--primary);
}

button.ui-link {
  padding: 0;
  border: 0;
  background: none;
  font-family: var(--font);
  font-size: inherit;
  line-height: inherit;
  cursor: pointer;
}

/* Card */
.ui-card {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  box-sizing: border-box;
  color: var(--text-primary);
}

.ui-card--lg {
  padding: var(--space-6);
}

a.ui-card,
button.ui-card {
  text-decoration: none;
  cursor: pointer;
  transition:
    box-shadow var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}

a.ui-card:hover,
button.ui-card:hover {
  box-shadow: var(--shadow-sm);
  border-color: var(--border-dark);
}

.ui-card-header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}

.ui-card-header > svg {
  width: 20px;
  height: 20px;
  color: var(--primary);
  flex: none;
  margin-top: 3px;
}

.ui-card-header-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.ui-card-header h1,
.ui-card-header h2,
.ui-card-header h3 {
  margin: 0;
}

.ui-card-header p {
  margin: 0;
  color: var(--text-secondary);
  max-width: 60ch;
}

.ui-card-body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* Two columns inside a card - single column below 820px. media first */
.ui-split {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-5);
  align-items: center;
}

.ui-split--media-right > .ui-media {
  order: 2;
}

@media (max-width: 820px) {
  .ui-split {
    grid-template-columns: minmax(0, 1fr);
  }

  .ui-split--media-right > .ui-media {
    order: -1;
  }
}

/* Section label */
.ui-section-label {
  margin: 0;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Buttons */
.ui-btn {
  --btn-bg: var(--primary);
  --btn-bg-hover: var(--primary-light);
  --btn-fg: var(--text-on-primary);
  --btn-border: transparent;
  --btn-shadow: var(--shadow-brand);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 9px 18px;
  border: 1px solid var(--btn-border);
  border-radius: var(--radius-md);
  background: var(--btn-bg);
  color: var(--btn-fg);
  font-family: var(--font);
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: 0.005em;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: var(--btn-shadow);
  box-sizing: border-box;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
}

.ui-btn svg {
  flex: none;
  width: 17px;
  height: 17px;
}

.ui-btn:hover {
  background: var(--btn-bg-hover);
  color: var(--btn-fg);
}

.ui-btn:active {
  transform: translateY(1px);
}

.ui-btn:disabled,
.ui-btn[aria-disabled='true'] {
  background: var(--bg-secondary);
  border-color: var(--border);
  color: var(--text-secondary);
  box-shadow: none;
  cursor: not-allowed;
}

.ui-btn--inverted {
  --btn-bg: #fff;
  --btn-bg-hover: var(--surface-brand-wash);
  --btn-fg: var(--primary);
  --btn-shadow: none;
}

.ui-btn--secondary {
  --btn-bg: #fff;
  --btn-bg-hover: var(--bg-secondary);
  --btn-fg: var(--text-primary);
  --btn-border: var(--border-dark);
  --btn-shadow: none;
}

.ui-btn--ghost {
  --btn-bg: transparent;
  --btn-bg-hover: var(--surface-brand-wash);
  --btn-fg: var(--primary);
  --btn-shadow: none;
}

.ui-btn--ghost:active {
  opacity: 0.7;
}

.ui-btn--danger {
  --btn-bg: transparent;
  --btn-bg-hover: var(--surface-error);
  --btn-fg: #c62828;
  --btn-border: rgba(244, 67, 54, 0.32);
  --btn-shadow: none;
}

.ui-btn--sm {
  min-height: 32px;
  padding: 6px 12px;
  font-size: 0.875rem;
}

.ui-btn--sm svg {
  width: 15px;
  height: 15px;
}

.ui-btn--lg {
  min-height: 46px;
  padding: 12px 26px;
  font-size: 1.0625rem;
}

.ui-btn--full {
  width: 100%;
}

@media (max-width: 480px) {
  .ui-btn--full-sm {
    width: 100%;
  }
}

.ui-btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

/* Icon button */
.ui-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: none;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    opacity var(--dur-fast) var(--ease-standard);
}

.ui-icon-btn svg {
  width: 20px;
  height: 20px;
}

.ui-icon-btn:hover {
  background: var(--bg-secondary);
}

.ui-icon-btn:active {
  opacity: 0.7;
}

.ui-icon-btn--neutral {
  background: var(--bg-secondary);
}

.ui-icon-btn--neutral:hover {
  background: var(--gray-200);
}

.ui-icon-btn--brand {
  background: var(--primary);
  color: #fff;
  box-shadow: var(--shadow-brand);
}

.ui-icon-btn--brand:hover {
  background: var(--primary-light);
}

.ui-icon-btn--round {
  border-radius: var(--radius-full);
}

/* Brand spinner */
.ui-spinner {
  display: inline-block;
  width: 17px;
  height: 17px;
  border: 2px solid var(--surface-selected-soft);
  border-top-color: var(--primary);
  border-radius: var(--radius-full);
  animation: ui-spin 700ms linear infinite;
}

.ui-btn .ui-spinner {
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
}

@keyframes ui-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Hero panel */
.ui-hero-panel {
  position: relative;
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  background: var(--primary);
  color: var(--text-on-primary);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  box-sizing: border-box;
}

@media (min-width: 821px) {
  .ui-hero-panel {
    padding: var(--space-8);
  }
}

/* Soft plum wash */
.ui-hero-panel:not(.ui-hero-panel--subtle) {
  background-image: radial-gradient(
    120% 140% at 8% 0%,
    var(--primary-light) 0%,
    var(--primary) 46%,
    var(--primary-dark) 100%
  );
}

.ui-hero-panel .ui-section-label,
.ui-hero-panel p.ui-section-label {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  opacity: 1;
  max-width: none;
}

.ui-hero-panel h1,
.ui-hero-panel h2 {
  color: inherit;
  font-weight: 700;
  letter-spacing: -0.024em;
  line-height: 1.18;
}

.ui-hero-panel h1 {
  font-size: clamp(1.6rem, 1.28rem + 1.05vw, 2.15rem);
  line-height: 1.13;
}

.ui-hero-panel h2 {
  font-size: clamp(1.28rem, 1.14rem + 0.42vw, 1.5rem);
}

.ui-hero-panel p {
  font-size: 1rem;
  line-height: 1.55;
  opacity: 0.92;
  max-width: 48ch;
}

.ui-hero-panel--subtle {
  background: var(--surface-brand-wash);
  color: var(--text-primary);
  border: 1px solid var(--surface-selected);
  box-shadow: none;
}

.ui-hero-panel--subtle .ui-section-label,
.ui-hero-panel--subtle p.ui-section-label {
  color: var(--primary);
}

.ui-hero-panel--subtle p {
  color: var(--text-secondary);
  opacity: 1;
}

.ui-hero-panel .ui-hero-copy {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.ui-hero-panel.ui-hero-panel--split {
  display: grid;
  background-image: none;
  grid-template-columns: minmax(0, 1.02fr) minmax(300px, .98fr);
  gap: var(--space-8);
  align-items: stretch;
  overflow: hidden;
}

.ui-hero-media {
  position: relative;
  overflow: hidden;
  background: var(--primary-dark);
  min-height: 300px;
}

.ui-hero-media > img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (min-width: 821px) {
  .ui-hero-panel--split > .ui-hero-media {
    margin: calc(-1 * var(--space-8)) calc(-1 * var(--space-8)) calc(-1 * var(--space-8)) 0;
  }
}

@media (max-width: 820px) {
  /* Match the base rule's specificity so the stack actually wins on phones. */
  .ui-hero-panel.ui-hero-panel--split { grid-template-columns: minmax(0, 1fr); gap: var(--space-5); }
  .ui-hero-panel--split > .ui-hero-media {
    order: -1;
    justify-self: stretch;
    margin: calc(-1 * var(--space-5)) calc(-1 * var(--space-5)) 0;
    min-height: 0;
    aspect-ratio: 16 / 9;
  }
}

.ui-band-inner {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 var(--gutter);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.ui-fact-strip { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); margin: 0; padding: var(--space-4) 0 0; }
.ui-fact { display: flex; flex-direction: column; gap: 2px; padding: 0 var(--space-6); border-left: 1px solid var(--border); }
.ui-fact:first-child { padding-left: 0; border-left: 0; }
.ui-fact:last-child { padding-right: 0; }
.ui-fact-icon { width: 19px; height: 19px; color: var(--primary); margin-bottom: var(--space-2); }
.ui-fact-label { margin: 0; font-size: .8125rem; font-weight: 600; color: var(--text-secondary); }
.ui-fact-value { margin: 0; font-size: clamp(1.2rem, 1.05rem + .5vw, 1.5rem); font-weight: 700; line-height: 1.2; color: var(--text-primary); }
.ui-fact-sub { margin: 4px 0 0; font-size: .875rem; color: var(--text-secondary); max-width: 32ch; }
/* Phones keep the three facts side by side as a compact row, not three tall stacks. */
@media (max-width: 700px) {
  .ui-fact-strip { padding-top: var(--space-4); border-top: 1px solid var(--border); }
  .ui-fact { padding: 0 var(--space-3); }
  .ui-fact-icon { width: 16px; height: 16px; margin-bottom: var(--space-1); }
  .ui-fact-label { font-size: .6875rem; }
  .ui-fact-value { font-size: .9375rem; line-height: 1.25; }
  .ui-fact-sub { font-size: .75rem; line-height: 1.4; margin-top: 2px; }
}

.ui-fact-strip--4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
@media (min-width: 420px) and (max-width: 767px) {
  .ui-fact-strip--4 { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 0; }
  .ui-fact-strip--4 .ui-fact { border-top: 0; border-left: 1px solid var(--border); padding: 0 1.5rem; }
  .ui-fact-strip--4 .ui-fact:nth-child(odd) { border-left: 0; padding-left: 0; }
}
@media (max-width: 419px) {
  .ui-fact-strip--4 { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--space-4) 0; border-top: 0; }
  .ui-fact-strip--4 .ui-fact { padding: 0 var(--space-4); border-top: 0; border-left: 1px solid var(--border); }
  .ui-fact-strip--4 .ui-fact:nth-child(odd) { border-left: 0; padding-left: 0; }
}
.research-text-link { display: inline-flex; align-items: center; gap: .35rem; min-height: 44px; text-decoration: underline; }

.ui-hero-panel .ui-hero-copy .ui-btn,
.ui-hero-panel .ui-hero-copy .ui-btn-row {
  margin-top: var(--space-2);
  align-self: flex-start;
}

.ui-hero-panel .ui-media {
  outline: 1px solid rgba(255, 255, 255, 0.28);
  outline-offset: -1px;
  border-radius: var(--radius-lg);
}

.ui-hero-panel--subtle .ui-media {
  outline: none;
}

@media (max-width: 480px) {
  .ui-hero-panel .ui-hero-copy .ui-btn {
    align-self: stretch;
  }
}

/* Stat tiles */
.ui-stat-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(158px, 1fr));
  gap: var(--space-2);
}

@media (max-width: 480px) {
  .ui-stat-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

.ui-stat-tile {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xs);
  padding: var(--space-3) var(--space-4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-height: 86px;
  box-sizing: border-box;
}

.ui-stat-tile > svg {
  width: 17px;
  height: 17px;
  color: var(--primary);
}

.ui-stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.028em;
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.ui-stat-tile .ui-section-label {
  margin-top: 2px;
  color: var(--text-secondary);
}

.ui-stat-sub {
  font-size: 0.75rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.ui-stat-tile--highlight {
  background: var(--surface-brand-wash);
  border-color: var(--primary);
}

.ui-stat-tile--highlight .ui-stat-value,
.ui-stat-tile--highlight .ui-section-label {
  color: var(--primary);
}

/* List rows */
.ui-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.ui-list-row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border-light);
  color: var(--text-primary);
  text-decoration: none;
  min-height: 40px;
  box-sizing: border-box;
}

.ui-list-row:last-child {
  border-bottom: none;
}

.ui-list-row--top {
  align-items: flex-start;
}

a.ui-list-row,
button.ui-list-row {
  cursor: pointer;
  width: 100%;
  text-align: left;
  background: transparent;
  border-left: none;
  border-right: none;
  border-top: none;
  font: inherit;
  margin: 0 calc(-1 * var(--space-2));
  width: calc(100% + 2 * var(--space-2));
  padding-left: var(--space-2);
  padding-right: var(--space-2);
  border-radius: var(--radius-md);
  transition: background-color var(--dur-fast) var(--ease-standard);
}

a.ui-list-row:hover,
button.ui-list-row:hover {
  background: var(--bg-tertiary);
}

a.ui-list-row:hover .ui-list-trailing,
button.ui-list-row:hover .ui-list-trailing {
  color: var(--primary);
}

.ui-icon-chip {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-sm);
  background: var(--surface-brand-wash);
  color: var(--primary);
  font-size: 0.875rem;
  font-weight: 700;
}

.ui-icon-chip svg {
  width: 16px;
  height: 16px;
}

.ui-icon-chip--white {
  background: #fff;
}

.ui-icon-chip--lg {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
}

.ui-icon-chip--lg svg {
  width: 20px;
  height: 20px;
}

.ui-list-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ui-list-label {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.ui-list-desc {
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--text-secondary);
}

.ui-list-trailing {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-secondary);
  transition: color var(--dur-fast) var(--ease-standard);
}

.ui-list-trailing svg {
  width: 16px;
  height: 16px;
}

/* Bulleted rows without chips */
.ui-bullets {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.ui-bullets li {
  position: relative;
  padding-left: 15px;
  line-height: 1.5;
}

.ui-bullets li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.62em;
  width: 5px;
  height: 5px;
  border-radius: var(--radius-full);
  background: var(--primary);
}

/* Highlight row */
.ui-highlight-row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--surface-brand-wash);
  border: 1px solid var(--surface-selected);
  color: var(--text-primary);
  text-decoration: none;
  min-height: 40px;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ui-highlight-row .ui-icon-chip {
  background: #fff;
}

.ui-highlight-row .ui-list-label {
  font-weight: 700;
}

a.ui-highlight-row:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow-sm);
}

a.ui-highlight-row:hover .ui-list-trailing {
  color: var(--primary);
}

/* Inputs */
.ui-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.ui-label {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.ui-label-optional {
  font-weight: 400;
  color: var(--text-secondary);
}

.ui-input {
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ui-input::placeholder {
  color: var(--text-placeholder);
}

.ui-input:focus,
.ui-input:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.ui-input[aria-invalid='true'] {
  border-color: var(--error);
}

.ui-input:disabled {
  background: var(--bg-secondary);
  color: var(--text-disabled);
  cursor: not-allowed;
}

select.ui-input {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 34px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
}

textarea.ui-input {
  min-height: 108px;
  resize: vertical;
}

.ui-help {
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.ui-error-text {
  font-size: 0.8125rem;
  line-height: 1.5;
  font-weight: 600;
  color: var(--error);
}

.ui-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-3);
}

@media (max-width: 560px) {
  .ui-field-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  /* Short paired fields (first/last name, state/zip) stay side by side. */
  .ui-field-grid.ui-field-grid--pair {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Segmented control */
.ui-segmented {
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 2px;
  padding: 3px;
  border-radius: var(--radius-md);
  background: var(--bg-secondary);
  border: 1px solid var(--border-light);
  box-sizing: border-box;
}

.ui-segmented--full {
  display: grid;
  width: 100%;
}

.ui-segmented > button {
  min-height: 32px;
  padding: 6px 14px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font);
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ui-segmented > button:hover {
  color: var(--text-primary);
}

.ui-segmented > button[aria-checked='true'],
.ui-segmented > button[aria-selected='true'],
.ui-segmented > button.is-active {
  background: var(--bg);
  color: var(--primary);
  font-size: 0.8125rem;
  font-weight: 700;
  box-shadow: var(--shadow-xs);
}

/* Badge */
.ui-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: var(--radius-xs);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.02em;
  white-space: nowrap;
  background: var(--surface-brand-wash);
  color: var(--primary);
}

.ui-badge svg {
  width: 12px;
  height: 12px;
}

.ui-badge--neutral {
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

.ui-badge--success {
  background: rgba(76, 175, 80, 0.12);
  color: #2e7d32;
}

.ui-badge--warning {
  background: rgba(255, 152, 0, 0.12);
  color: #b26a00;
}

.ui-badge--error {
  background: rgba(244, 67, 54, 0.12);
  color: #c62828;
}

/* Banner */
.ui-banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  background: var(--surface-info);
  color: #0d47a1;
}

.ui-banner > svg {
  width: 17px;
  height: 17px;
  flex: none;
  margin-top: 1px;
}

.ui-banner p {
  margin: 0;
}

/* A text-only banner flows as one paragraph so inline links wrap with the words. */
p.ui-banner {
  display: block;
}

.ui-banner--success {
  background: var(--surface-success);
  color: #1b5e20;
}

.ui-banner--warning {
  background: var(--surface-warning);
  color: #8a4b00;
}

.ui-banner--error {
  background: var(--surface-error);
  color: #b71c1c;
}

.ui-banner--brand {
  background: var(--surface-brand-wash);
  color: var(--primary-dark);
}

/* Avatar */
.ui-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-full);
  background: var(--primary);
  color: #fff;
  font-size: 0.9375rem;
  font-weight: 700;
  box-shadow: none;
  overflow: hidden;
  flex: none;
}

.ui-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Divider */
.ui-divider {
  height: 1px;
  background: var(--border-light);
  border: none;
  margin: 0;
}

.ui-divider--strong {
  background: var(--border);
  margin: var(--space-2) 0;
}

/* Media frame */
.ui-media {
  position: relative;
  width: 100%;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: #1c1c1e;
  aspect-ratio: 4 / 3;
}

.ui-media > img,
.ui-media > video,
.ui-media > iframe {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: 0;
}

.ui-media--square {
  aspect-ratio: 1 / 1;
}

.ui-media--wide {
  aspect-ratio: 16 / 9;
}

.ui-media--video {
  aspect-ratio: 16 / 9;
}

/* For photos taller than they are wide. Held to a readable column width so a
   portrait shot does not stretch a full-width frame into two black margins. */
.ui-media--portrait {
  aspect-ratio: 3 / 4;
  max-width: 380px;
  margin-inline: auto;
}

/* Opt in to cropping only where the frame is decorative, not the subject. */
.ui-media--cover > img,
.ui-media--cover > video {
  object-fit: cover;
}

/* Kept for callers that still ask for it explicitly; \`contain\` is the default. */
.ui-media--contain > img {
  object-fit: contain;
}

/* A light frame for artwork and diagrams that would look wrong on black. */
.ui-media--paper {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-light);
}

.ui-media--lg {
  border-radius: var(--radius-lg);
}

.ui-caption {
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--text-secondary);
  text-align: center;
}

/* Carousel */
.ui-carousel {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border-radius: var(--radius-md);
}

.ui-carousel:focus {
  outline: none;
}

.ui-carousel:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 4px;
}

.ui-carousel-viewport { position: relative; overflow: hidden; touch-action: pan-y; }
.ui-carousel-track {
  --gap: var(--space-3);
  display: flex;
  gap: var(--gap);
  transform: translateX(calc(-1 * var(--pos) * ((100% + var(--gap)) / var(--per-view))));
  transition: transform 700ms var(--ease-standard);
}
.ui-carousel-track[data-instant] { transition: none; }
.ui-carousel-slide { flex: 0 0 calc((100% + var(--gap)) / var(--per-view) - var(--gap)); min-width: 0; margin: 0; }
.ui-carousel-slide .ui-media { width: 100%; }
.ui-carousel-controls { display: flex; justify-content: center; align-items: center; gap: var(--space-2); }
.ui-carousel-toggle { width: 44px; height: 44px; border: 0; border-radius: var(--radius-full); background: var(--bg-secondary); color: var(--text-primary); cursor: pointer; }
.ui-carousel-toggle svg { width: 18px; height: 18px; }

.ui-carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius-full);
  background: rgba(255, 255, 255, 0.92);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    color var(--dur-fast) var(--ease-standard),
    opacity var(--dur-fast) var(--ease-standard);
}

.ui-carousel-nav svg {
  width: 17px;
  height: 17px;
}

.ui-carousel-nav:hover {
  color: var(--primary);
}

.ui-carousel-nav:active {
  opacity: 0.7;
}

.ui-carousel-nav--prev {
  left: 10px;
}

.ui-carousel-nav--next {
  right: 10px;
}

.ui-carousel-dots {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
}

.ui-carousel-dot {
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ui-carousel-dot::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--border);
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    width var(--dur-fast) var(--ease-standard),
    height var(--dur-fast) var(--ease-standard);
}

.ui-carousel-dot:hover::before {
  background: var(--border-dark);
}

.ui-carousel-dot.is-active::before {
  width: 10px;
  height: 10px;
  background: var(--primary);
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .ui-container,
  .site-main,
  .site-reveal,
  .ui-spinner {
    animation: none !important;
  }

  .ui-btn,
  .ui-btn:active,
  .ui-icon-btn,
  .ui-input,
  .ui-segmented > button,
  .ui-carousel-nav,
  .ui-carousel-track,
  .ui-carousel-toggle,
  .ui-carousel-dot::before,
  .ui-highlight-row,
  a.ui-card,
  a.ui-list-row,
  button.ui-list-row {
    transition: none !important;
  }
}

/* Scroll reveal */
.ui-reveal {
  opacity: 0;
  transform: translateY(10px);
  transition:
    opacity 520ms var(--ease-standard),
    transform 520ms var(--ease-standard);
}

.ui-reveal.is-visible {
  opacity: 1;
  transform: none;
}

.ui-reveal--stagger > * {
  opacity: 0;
  transform: translateY(10px);
  transition:
    opacity 520ms var(--ease-standard),
    transform 520ms var(--ease-standard);
  transition-delay: calc(var(--reveal-index, 0) * 90ms);
}

.ui-reveal--stagger.is-visible > * {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .ui-reveal,
  .ui-reveal.is-visible,
  .ui-reveal--stagger > *,
  .ui-reveal--stagger.is-visible > * {
    opacity: 1;
    transform: none;
    transition: none !important;
  }
}

/* Phones
 * One place that scales the system down for small screens: tighter gutters,
 * smaller type and padding, and image frames that never eat the whole viewport.
 */
@media (max-width: 560px) {
  :root {
    --gutter: 16px;
  }

  h1 {
    font-size: 1.4rem;
  }

  h2 {
    font-size: 1.08rem;
  }

  .ui-page,
  .site-page-bg {
    padding: var(--space-3) 0 var(--space-8);
  }

  .ui-page-header p,
  .site-page-lead {
    font-size: .9375rem;
  }

  .ui-card {
    padding: var(--space-4);
    border-radius: var(--radius-md);
  }

  .ui-card--lg {
    padding: var(--space-4);
  }

  .ui-card-header p {
    font-size: .875rem;
  }

  .ui-hero-panel {
    padding: var(--space-4);
    border-radius: var(--radius-lg);
  }

  .ui-hero-panel h1 {
    font-size: 1.45rem;
  }

  .ui-hero-panel h2 {
    font-size: 1.2rem;
  }

  .ui-hero-panel p {
    font-size: .9375rem;
  }

  .ui-hero-panel.ui-hero-panel--split {
    gap: var(--space-4);
  }

  .ui-hero-panel--split > .ui-hero-media {
    margin: calc(-1 * var(--space-4)) calc(-1 * var(--space-4)) 0;
  }

  .ui-btn--lg {
    min-height: 44px;
    padding: 10px 20px;
    font-size: .9375rem;
  }

  .ui-media--portrait {
    max-width: 280px;
  }

  .ui-list-label {
    font-size: .875rem;
  }

  .ui-list-desc {
    font-size: .8125rem;
  }

  .ui-caption {
    font-size: .8125rem;
  }

  /* Inside a sentence the link flows with the text instead of padding the line. */
  p > .research-text-link {
    display: inline;
    min-height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/siteShell.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAGF;EACE,SAAS;EACT,kEAAkE;;EAElE,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;;EAEnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,cAAc;EACd,6CAA6C;EAC7C;;oCAEkC;EAClC;;qCAEmC;EACnC;;sCAEoC;EACpC,gDAAgD;;EAEhD,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,uCAAuC;EACvC,4CAA4C;EAC5C,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;;EAE7B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,yEAAyE;EACzE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;;;EAME,SAAS;EACT,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA,kBAAkB;AAClB;;EAEE,SAAO;EACP,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf;;qDAEmD;AACrD;;AAEA;;EAEE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,iCAAiC;;EAEjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB;;;;kDAIgD;AAClD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf;;;gDAG8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,gCAAgC;EAChC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;GAKC;AACH;;AAEA;;EAEE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6DAA6D;EAC7D,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uFAAuF;EACzF;AACF;;AAEA;EACE,4EAA4E;EAC5E,sCAAsC,qCAAqC,EAAE,mBAAmB,EAAE;EAClG;IACE,SAAS;IACT,qBAAqB;IACrB,6DAA6D;IAC7D,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iBAAiB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,2BAA2B,EAAE;AAC1H,WAAW,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,yBAAyB,EAAE,oCAAoC,EAAE;AAC7H,uBAAuB,eAAe,EAAE,cAAc,EAAE;AACxD,sBAAsB,gBAAgB,EAAE;AACxC,gBAAgB,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE,6BAA6B,EAAE;AACjG,iBAAiB,SAAS,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACjG,iBAAiB,SAAS,EAAE,gDAAgD,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC9I,eAAe,eAAe,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,eAAe,EAAE;AACnG,sFAAsF;AACtF;EACE,iBAAiB,2BAA2B,EAAE,mCAAmC,EAAE;EACnF,WAAW,yBAAyB,EAAE;EACtC,gBAAgB,WAAW,EAAE,YAAY,EAAE,6BAA6B,EAAE;EAC1E,iBAAiB,mBAAmB,EAAE;EACtC,iBAAiB,mBAAmB,EAAE,iBAAiB,EAAE;EACzD,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACvE;;AAEA,oBAAoB,gDAAgD,EAAE;AACtE;EACE,oBAAoB,gDAAgD,EAAE,aAAa,EAAE;EACrF,6BAA6B,aAAa,EAAE,oCAAoC,EAAE,iBAAiB,EAAE;EACrG,4CAA4C,cAAc,EAAE,eAAe,EAAE;AAC/E;AACA;EACE,oBAAoB,gDAAgD,EAAE,qBAAqB,EAAE,aAAa,EAAE;EAC5G,6BAA6B,yBAAyB,EAAE,aAAa,EAAE,oCAAoC,EAAE;EAC7G,4CAA4C,cAAc,EAAE,eAAe,EAAE;AAC/E;AACA,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAE5H;;EAEE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,iEAAiE;AACnE;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,yCAAyC;EACzC,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yDAAuR;EACvR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA,wEAAwE;EACxE;IACE,gDAAgD;EAClD;AACF;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;EACjC,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;;mDAGiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,mFAAmF;AACnF;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;8EAC8E;AAC9E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;;EAEE,iBAAiB;AACnB;;AAEA,iFAAiF;AACjF;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACnF;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,sFAAsF;EACtF,gDAAgD;AAClD;AACA,mCAAmC,gBAAgB,EAAE;AACrD,qBAAqB,kEAAkE,EAAE,YAAY,EAAE,SAAS,EAAE;AAClH,+BAA+B,WAAW,EAAE;AAC5C,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC1G,sBAAsB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,iCAAiC,EAAE,+BAA+B,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC7K,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;gDAE8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB;;;+CAG6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;;;;;;;;;;;;;IAaE,2BAA2B;EAC7B;AACF;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,2BAA2B;EAC3B;;wCAEsC;AACxC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B;;wCAEsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;;;;IAIE,UAAU;IACV,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;;;EAGE;AACF;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,gFAAgF;EAChF;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":["/*\n * mRehab web design system.\n * Imported once from app.tsx. Page modules hold layout only.\n */\n@import url('../colors.css');\n\n:root {\n  /* Type */\n  --font: 'Open Sans', -apple-system, 'Segoe UI', Roboto, sans-serif;\n\n  /* Spacing (4px base) */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 10px;\n  --space-4: 14px;\n  --space-5: 18px;\n  --space-6: 20px;\n  --space-8: 28px;\n  --space-12: 36px;\n  --space-16: 48px;\n  --gutter: 20px;\n  --container: 1160px;\n\n  /* Radius */\n  --radius-xs: 3px;\n  --radius-sm: 6px;\n  --radius-input: 8px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 18px;\n  --radius-full: 9999px;\n\n  /* Elevation */\n  --shadow-xs: 0 1px 1px rgba(40, 26, 34, 0.04);\n  --shadow-sm:\n    0 1px 1px rgba(40, 26, 34, 0.04),\n    0 2px 6px rgba(40, 26, 34, 0.05);\n  --shadow-md:\n    0 1px 2px rgba(40, 26, 34, 0.05),\n    0 6px 18px rgba(40, 26, 34, 0.08);\n  --shadow-lg:\n    0 2px 4px rgba(40, 26, 34, 0.05),\n    0 16px 40px rgba(40, 26, 34, 0.11);\n  --shadow-brand: 0 1px 2px rgba(122, 24, 71, 0.2);\n\n  /* Motion */\n  --dur-fast: 160ms;\n  --dur-med: 260ms;\n  --ease-standard: cubic-bezier(0.2, 0, 0, 1);\n  /* Legacy names used by older modules */\n  --motion-ease-standard: var(--ease-standard);\n  --motion-fast: var(--dur-fast);\n  --motion-medium: var(--dur-med);\n  --motion-slow: var(--dur-med);\n\n  /* Legacy shell tokens */\n  --site-paper: var(--bg);\n  --site-paper-2: var(--bg);\n  --site-ink: var(--text-primary);\n  --site-radius-lg: var(--radius-lg);\n  --site-shadow: var(--shadow-sm);\n}\n\n/* Base */\nhtml {\n  /* 15px base: every rem-sized type and gap in the app tightens with it. */\n  font-size: 93.75%;\n  -webkit-text-size-adjust: 100%;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font);\n  font-size: 1rem;\n  line-height: 1.55;\n  color: var(--text-primary);\n  background: var(--bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n#root {\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  color: var(--text-primary);\n  font-family: var(--font);\n  text-wrap: balance;\n}\n\nh1 {\n  font-size: clamp(1.5rem, 1.24rem + 0.8vw, 1.9rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n}\n\nh2 {\n  font-size: clamp(1.1rem, 1.02rem + 0.32vw, 1.28rem);\n  font-weight: 600;\n  line-height: 1.28;\n  letter-spacing: -0.014em;\n}\n\nh3 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.35;\n  letter-spacing: -0.008em;\n}\n\np {\n  margin: 0;\n  text-wrap: pretty;\n}\n\nimg,\nvideo,\niframe {\n  max-width: 100%;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n}\n\n:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n::selection {\n  background: var(--surface-selected);\n}\n\n.ui-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Skip link */\n.ui-skip-link {\n  position: absolute;\n  top: -100px;\n  left: var(--gutter);\n  z-index: 1000;\n  padding: 10px 16px;\n  border-radius: var(--radius-md);\n  background: var(--bg);\n  color: var(--primary);\n  font-weight: 700;\n  text-decoration: none;\n  box-shadow: var(--shadow-brand);\n}\n\n.ui-skip-link:focus-visible {\n  top: 12px;\n}\n\n/* Page + column */\n.ui-page,\n.site-page-bg {\n  flex: 1;\n  background: var(--bg);\n  padding: var(--space-4) 0 var(--space-12);\n}\n\n.ui-container,\n.site-main {\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .ui-container,\n  .site-main,\n  .site-reveal {\n    animation: ui-fade-in var(--dur-med) var(--ease-standard) both;\n  }\n}\n\n@keyframes ui-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ui-page-header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  padding: var(--space-1) 0 0;\n}\n\n.ui-page-header h1,\n.site-page-title {\n  margin: 0;\n}\n\n.ui-page-header p,\n.site-page-lead {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 62ch;\n}\n\n.ui-page-header p a,\n.site-page-lead a {\n  color: var(--link);\n  font-weight: 600;\n}\n\n/* Breadcrumb */\n.ui-breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.ui-breadcrumb a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 600;\n  padding: 6px 0;\n}\n\n.ui-breadcrumb a:hover {\n  color: var(--primary);\n}\n\n/* Inline text links inside body copy */\n.ui-link {\n  color: var(--link);\n  font-weight: 600;\n  text-decoration: underline;\n  text-decoration-thickness: 0.09em;\n  text-underline-offset: 0.16em;\n}\n\n.ui-link:hover {\n  color: var(--primary);\n}\n\nbutton.ui-link {\n  padding: 0;\n  border: 0;\n  background: none;\n  font-family: var(--font);\n  font-size: inherit;\n  line-height: inherit;\n  cursor: pointer;\n}\n\n/* Card */\n.ui-card {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xs);\n  padding: var(--space-4);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  box-sizing: border-box;\n  color: var(--text-primary);\n}\n\n.ui-card--lg {\n  padding: var(--space-6);\n}\n\na.ui-card,\nbutton.ui-card {\n  text-decoration: none;\n  cursor: pointer;\n  transition:\n    box-shadow var(--dur-fast) var(--ease-standard),\n    border-color var(--dur-fast) var(--ease-standard);\n}\n\na.ui-card:hover,\nbutton.ui-card:hover {\n  box-shadow: var(--shadow-sm);\n  border-color: var(--border-dark);\n}\n\n.ui-card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n\n.ui-card-header > svg {\n  width: 20px;\n  height: 20px;\n  color: var(--primary);\n  flex: none;\n  margin-top: 3px;\n}\n\n.ui-card-header-text {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.ui-card-header h1,\n.ui-card-header h2,\n.ui-card-header h3 {\n  margin: 0;\n}\n\n.ui-card-header p {\n  margin: 0;\n  color: var(--text-secondary);\n  max-width: 60ch;\n}\n\n.ui-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/* Two columns inside a card - single column below 820px. media first */\n.ui-split {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--space-5);\n  align-items: center;\n}\n\n.ui-split--media-right > .ui-media {\n  order: 2;\n}\n\n@media (max-width: 820px) {\n  .ui-split {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .ui-split--media-right > .ui-media {\n    order: -1;\n  }\n}\n\n/* Section label */\n.ui-section-label {\n  margin: 0;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  line-height: 1.45;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-primary);\n}\n\n/* Buttons */\n.ui-btn {\n  --btn-bg: var(--primary);\n  --btn-bg-hover: var(--primary-light);\n  --btn-fg: var(--text-on-primary);\n  --btn-border: transparent;\n  --btn-shadow: var(--shadow-brand);\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 9px 18px;\n  border: 1px solid var(--btn-border);\n  border-radius: var(--radius-md);\n  background: var(--btn-bg);\n  color: var(--btn-fg);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.35;\n  letter-spacing: 0.005em;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: var(--btn-shadow);\n  box-sizing: border-box;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    border-color var(--dur-fast) var(--ease-standard),\n    color var(--dur-fast) var(--ease-standard),\n    transform var(--dur-fast) var(--ease-standard);\n}\n\n.ui-btn svg {\n  flex: none;\n  width: 17px;\n  height: 17px;\n}\n\n.ui-btn:hover {\n  background: var(--btn-bg-hover);\n  color: var(--btn-fg);\n}\n\n.ui-btn:active {\n  transform: translateY(1px);\n}\n\n.ui-btn:disabled,\n.ui-btn[aria-disabled='true'] {\n  background: var(--bg-secondary);\n  border-color: var(--border);\n  color: var(--text-secondary);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.ui-btn--inverted {\n  --btn-bg: #fff;\n  --btn-bg-hover: var(--surface-brand-wash);\n  --btn-fg: var(--primary);\n  --btn-shadow: none;\n}\n\n.ui-btn--secondary {\n  --btn-bg: #fff;\n  --btn-bg-hover: var(--bg-secondary);\n  --btn-fg: var(--text-primary);\n  --btn-border: var(--border-dark);\n  --btn-shadow: none;\n}\n\n.ui-btn--ghost {\n  --btn-bg: transparent;\n  --btn-bg-hover: var(--surface-brand-wash);\n  --btn-fg: var(--primary);\n  --btn-shadow: none;\n}\n\n.ui-btn--ghost:active {\n  opacity: 0.7;\n}\n\n.ui-btn--danger {\n  --btn-bg: transparent;\n  --btn-bg-hover: var(--surface-error);\n  --btn-fg: #c62828;\n  --btn-border: rgba(244, 67, 54, 0.32);\n  --btn-shadow: none;\n}\n\n.ui-btn--sm {\n  min-height: 32px;\n  padding: 6px 12px;\n  font-size: 0.875rem;\n}\n\n.ui-btn--sm svg {\n  width: 15px;\n  height: 15px;\n}\n\n.ui-btn--lg {\n  min-height: 46px;\n  padding: 12px 26px;\n  font-size: 1.0625rem;\n}\n\n.ui-btn--full {\n  width: 100%;\n}\n\n@media (max-width: 480px) {\n  .ui-btn--full-sm {\n    width: 100%;\n  }\n}\n\n.ui-btn-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n/* Icon button */\n.ui-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    color var(--dur-fast) var(--ease-standard),\n    opacity var(--dur-fast) var(--ease-standard);\n}\n\n.ui-icon-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ui-icon-btn:hover {\n  background: var(--bg-secondary);\n}\n\n.ui-icon-btn:active {\n  opacity: 0.7;\n}\n\n.ui-icon-btn--neutral {\n  background: var(--bg-secondary);\n}\n\n.ui-icon-btn--neutral:hover {\n  background: var(--gray-200);\n}\n\n.ui-icon-btn--brand {\n  background: var(--primary);\n  color: #fff;\n  box-shadow: var(--shadow-brand);\n}\n\n.ui-icon-btn--brand:hover {\n  background: var(--primary-light);\n}\n\n.ui-icon-btn--round {\n  border-radius: var(--radius-full);\n}\n\n/* Brand spinner */\n.ui-spinner {\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  border: 2px solid var(--surface-selected-soft);\n  border-top-color: var(--primary);\n  border-radius: var(--radius-full);\n  animation: ui-spin 700ms linear infinite;\n}\n\n.ui-btn .ui-spinner {\n  border-color: rgba(255, 255, 255, 0.35);\n  border-top-color: #fff;\n}\n\n@keyframes ui-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Hero panel */\n.ui-hero-panel {\n  position: relative;\n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  box-sizing: border-box;\n}\n\n@media (min-width: 821px) {\n  .ui-hero-panel {\n    padding: var(--space-8);\n  }\n}\n\n/* Soft plum wash */\n.ui-hero-panel:not(.ui-hero-panel--subtle) {\n  background-image: radial-gradient(\n    120% 140% at 8% 0%,\n    var(--primary-light) 0%,\n    var(--primary) 46%,\n    var(--primary-dark) 100%\n  );\n}\n\n.ui-hero-panel .ui-section-label,\n.ui-hero-panel p.ui-section-label {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  line-height: 1.45;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  opacity: 1;\n  max-width: none;\n}\n\n.ui-hero-panel h1,\n.ui-hero-panel h2 {\n  color: inherit;\n  font-weight: 700;\n  letter-spacing: -0.024em;\n  line-height: 1.18;\n}\n\n.ui-hero-panel h1 {\n  font-size: clamp(1.6rem, 1.28rem + 1.05vw, 2.15rem);\n  line-height: 1.13;\n}\n\n.ui-hero-panel h2 {\n  font-size: clamp(1.28rem, 1.14rem + 0.42vw, 1.5rem);\n}\n\n.ui-hero-panel p {\n  font-size: 1rem;\n  line-height: 1.55;\n  opacity: 0.92;\n  max-width: 48ch;\n}\n\n.ui-hero-panel--subtle {\n  background: var(--surface-brand-wash);\n  color: var(--text-primary);\n  border: 1px solid var(--surface-selected);\n  box-shadow: none;\n}\n\n.ui-hero-panel--subtle .ui-section-label,\n.ui-hero-panel--subtle p.ui-section-label {\n  color: var(--primary);\n}\n\n.ui-hero-panel--subtle p {\n  color: var(--text-secondary);\n  opacity: 1;\n}\n\n.ui-hero-panel .ui-hero-copy {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  min-width: 0;\n}\n\n.ui-hero-panel.ui-hero-panel--split {\n  display: grid;\n  background-image: none;\n  grid-template-columns: minmax(0, 1.02fr) minmax(300px, .98fr);\n  gap: var(--space-8);\n  align-items: stretch;\n  overflow: hidden;\n}\n\n.ui-hero-media {\n  position: relative;\n  overflow: hidden;\n  background: var(--primary-dark);\n  min-height: 300px;\n}\n\n.ui-hero-media > img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media (min-width: 821px) {\n  .ui-hero-panel--split > .ui-hero-media {\n    margin: calc(-1 * var(--space-8)) calc(-1 * var(--space-8)) calc(-1 * var(--space-8)) 0;\n  }\n}\n\n@media (max-width: 820px) {\n  /* Match the base rule's specificity so the stack actually wins on phones. */\n  .ui-hero-panel.ui-hero-panel--split { grid-template-columns: minmax(0, 1fr); gap: var(--space-5); }\n  .ui-hero-panel--split > .ui-hero-media {\n    order: -1;\n    justify-self: stretch;\n    margin: calc(-1 * var(--space-5)) calc(-1 * var(--space-5)) 0;\n    min-height: 0;\n    aspect-ratio: 16 / 9;\n  }\n}\n\n.ui-band-inner {\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-8);\n}\n\n.ui-fact-strip { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); margin: 0; padding: var(--space-4) 0 0; }\n.ui-fact { display: flex; flex-direction: column; gap: 2px; padding: 0 var(--space-6); border-left: 1px solid var(--border); }\n.ui-fact:first-child { padding-left: 0; border-left: 0; }\n.ui-fact:last-child { padding-right: 0; }\n.ui-fact-icon { width: 19px; height: 19px; color: var(--primary); margin-bottom: var(--space-2); }\n.ui-fact-label { margin: 0; font-size: .8125rem; font-weight: 600; color: var(--text-secondary); }\n.ui-fact-value { margin: 0; font-size: clamp(1.2rem, 1.05rem + .5vw, 1.5rem); font-weight: 700; line-height: 1.2; color: var(--text-primary); }\n.ui-fact-sub { margin: 4px 0 0; font-size: .875rem; color: var(--text-secondary); max-width: 32ch; }\n/* Phones keep the three facts side by side as a compact row, not three tall stacks. */\n@media (max-width: 700px) {\n  .ui-fact-strip { padding-top: var(--space-4); border-top: 1px solid var(--border); }\n  .ui-fact { padding: 0 var(--space-3); }\n  .ui-fact-icon { width: 16px; height: 16px; margin-bottom: var(--space-1); }\n  .ui-fact-label { font-size: .6875rem; }\n  .ui-fact-value { font-size: .9375rem; line-height: 1.25; }\n  .ui-fact-sub { font-size: .75rem; line-height: 1.4; margin-top: 2px; }\n}\n\n.ui-fact-strip--4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n@media (min-width: 420px) and (max-width: 767px) {\n  .ui-fact-strip--4 { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 0; }\n  .ui-fact-strip--4 .ui-fact { border-top: 0; border-left: 1px solid var(--border); padding: 0 1.5rem; }\n  .ui-fact-strip--4 .ui-fact:nth-child(odd) { border-left: 0; padding-left: 0; }\n}\n@media (max-width: 419px) {\n  .ui-fact-strip--4 { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--space-4) 0; border-top: 0; }\n  .ui-fact-strip--4 .ui-fact { padding: 0 var(--space-4); border-top: 0; border-left: 1px solid var(--border); }\n  .ui-fact-strip--4 .ui-fact:nth-child(odd) { border-left: 0; padding-left: 0; }\n}\n.research-text-link { display: inline-flex; align-items: center; gap: .35rem; min-height: 44px; text-decoration: underline; }\n\n.ui-hero-panel .ui-hero-copy .ui-btn,\n.ui-hero-panel .ui-hero-copy .ui-btn-row {\n  margin-top: var(--space-2);\n  align-self: flex-start;\n}\n\n.ui-hero-panel .ui-media {\n  outline: 1px solid rgba(255, 255, 255, 0.28);\n  outline-offset: -1px;\n  border-radius: var(--radius-lg);\n}\n\n.ui-hero-panel--subtle .ui-media {\n  outline: none;\n}\n\n@media (max-width: 480px) {\n  .ui-hero-panel .ui-hero-copy .ui-btn {\n    align-self: stretch;\n  }\n}\n\n/* Stat tiles */\n.ui-stat-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(158px, 1fr));\n  gap: var(--space-2);\n}\n\n@media (max-width: 480px) {\n  .ui-stat-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.ui-stat-tile {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-xs);\n  padding: var(--space-3) var(--space-4);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-height: 86px;\n  box-sizing: border-box;\n}\n\n.ui-stat-tile > svg {\n  width: 17px;\n  height: 17px;\n  color: var(--primary);\n}\n\n.ui-stat-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.028em;\n  font-variant-numeric: tabular-nums;\n  color: var(--text-primary);\n}\n\n.ui-stat-tile .ui-section-label {\n  margin-top: 2px;\n  color: var(--text-secondary);\n}\n\n.ui-stat-sub {\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.ui-stat-tile--highlight {\n  background: var(--surface-brand-wash);\n  border-color: var(--primary);\n}\n\n.ui-stat-tile--highlight .ui-stat-value,\n.ui-stat-tile--highlight .ui-section-label {\n  color: var(--primary);\n}\n\n/* List rows */\n.ui-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.ui-list-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--border-light);\n  color: var(--text-primary);\n  text-decoration: none;\n  min-height: 40px;\n  box-sizing: border-box;\n}\n\n.ui-list-row:last-child {\n  border-bottom: none;\n}\n\n.ui-list-row--top {\n  align-items: flex-start;\n}\n\na.ui-list-row,\nbutton.ui-list-row {\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  font: inherit;\n  margin: 0 calc(-1 * var(--space-2));\n  width: calc(100% + 2 * var(--space-2));\n  padding-left: var(--space-2);\n  padding-right: var(--space-2);\n  border-radius: var(--radius-md);\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\na.ui-list-row:hover,\nbutton.ui-list-row:hover {\n  background: var(--bg-tertiary);\n}\n\na.ui-list-row:hover .ui-list-trailing,\nbutton.ui-list-row:hover .ui-list-trailing {\n  color: var(--primary);\n}\n\n.ui-icon-chip {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-sm);\n  background: var(--surface-brand-wash);\n  color: var(--primary);\n  font-size: 0.875rem;\n  font-weight: 700;\n}\n\n.ui-icon-chip svg {\n  width: 16px;\n  height: 16px;\n}\n\n.ui-icon-chip--white {\n  background: #fff;\n}\n\n.ui-icon-chip--lg {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n}\n\n.ui-icon-chip--lg svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ui-list-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ui-list-label {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.ui-list-desc {\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.ui-list-trailing {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  color: var(--text-secondary);\n  transition: color var(--dur-fast) var(--ease-standard);\n}\n\n.ui-list-trailing svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Bulleted rows without chips */\n.ui-bullets {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.ui-bullets li {\n  position: relative;\n  padding-left: 15px;\n  line-height: 1.5;\n}\n\n.ui-bullets li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0.62em;\n  width: 5px;\n  height: 5px;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n}\n\n/* Highlight row */\n.ui-highlight-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--surface-brand-wash);\n  border: 1px solid var(--surface-selected);\n  color: var(--text-primary);\n  text-decoration: none;\n  min-height: 40px;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.ui-highlight-row .ui-icon-chip {\n  background: #fff;\n}\n\n.ui-highlight-row .ui-list-label {\n  font-weight: 700;\n}\n\na.ui-highlight-row:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-sm);\n}\n\na.ui-highlight-row:hover .ui-list-trailing {\n  color: var(--primary);\n}\n\n/* Inputs */\n.ui-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.ui-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.ui-label-optional {\n  font-weight: 400;\n  color: var(--text-secondary);\n}\n\n.ui-input {\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.ui-input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.ui-input:focus,\n.ui-input:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.ui-input[aria-invalid='true'] {\n  border-color: var(--error);\n}\n\n.ui-input:disabled {\n  background: var(--bg-secondary);\n  color: var(--text-disabled);\n  cursor: not-allowed;\n}\n\nselect.ui-input {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 512 512'%3E%3Cpath fill='none' stroke='%23616161' stroke-width='48' stroke-linecap='round' stroke-linejoin='round' d='M112 184l144 144 144-144'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 14px;\n}\n\ntextarea.ui-input {\n  min-height: 108px;\n  resize: vertical;\n}\n\n.ui-help {\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.ui-error-text {\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  font-weight: 600;\n  color: var(--error);\n}\n\n.ui-field-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-3);\n}\n\n@media (max-width: 560px) {\n  .ui-field-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  /* Short paired fields (first/last name, state/zip) stay side by side. */\n  .ui-field-grid.ui-field-grid--pair {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* Segmented control */\n.ui-segmented {\n  display: inline-grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(0, 1fr);\n  gap: 2px;\n  padding: 3px;\n  border-radius: var(--radius-md);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-light);\n  box-sizing: border-box;\n}\n\n.ui-segmented--full {\n  display: grid;\n  width: 100%;\n}\n\n.ui-segmented > button {\n  min-height: 32px;\n  padding: 6px 14px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--font);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.4;\n  cursor: pointer;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.ui-segmented > button:hover {\n  color: var(--text-primary);\n}\n\n.ui-segmented > button[aria-checked='true'],\n.ui-segmented > button[aria-selected='true'],\n.ui-segmented > button.is-active {\n  background: var(--bg);\n  color: var(--primary);\n  font-size: 0.8125rem;\n  font-weight: 700;\n  box-shadow: var(--shadow-xs);\n}\n\n/* Badge */\n.ui-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 7px;\n  border-radius: var(--radius-xs);\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  background: var(--surface-brand-wash);\n  color: var(--primary);\n}\n\n.ui-badge svg {\n  width: 12px;\n  height: 12px;\n}\n\n.ui-badge--neutral {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n.ui-badge--success {\n  background: rgba(76, 175, 80, 0.12);\n  color: #2e7d32;\n}\n\n.ui-badge--warning {\n  background: rgba(255, 152, 0, 0.12);\n  color: #b26a00;\n}\n\n.ui-badge--error {\n  background: rgba(244, 67, 54, 0.12);\n  color: #c62828;\n}\n\n/* Banner */\n.ui-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  background: var(--surface-info);\n  color: #0d47a1;\n}\n\n.ui-banner > svg {\n  width: 17px;\n  height: 17px;\n  flex: none;\n  margin-top: 1px;\n}\n\n.ui-banner p {\n  margin: 0;\n}\n\n/* A text-only banner flows as one paragraph so inline links wrap with the words. */\np.ui-banner {\n  display: block;\n}\n\n.ui-banner--success {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n.ui-banner--warning {\n  background: var(--surface-warning);\n  color: #8a4b00;\n}\n\n.ui-banner--error {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n.ui-banner--brand {\n  background: var(--surface-brand-wash);\n  color: var(--primary-dark);\n}\n\n/* Avatar */\n.ui-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n  color: #fff;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  box-shadow: none;\n  overflow: hidden;\n  flex: none;\n}\n\n.ui-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Divider */\n.ui-divider {\n  height: 1px;\n  background: var(--border-light);\n  border: none;\n  margin: 0;\n}\n\n.ui-divider--strong {\n  background: var(--border);\n  margin: var(--space-2) 0;\n}\n\n/* Media frame */\n.ui-media {\n  position: relative;\n  width: 100%;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: #1c1c1e;\n  aspect-ratio: 4 / 3;\n}\n\n.ui-media > img,\n.ui-media > video,\n.ui-media > iframe {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border: 0;\n}\n\n.ui-media--square {\n  aspect-ratio: 1 / 1;\n}\n\n.ui-media--wide {\n  aspect-ratio: 16 / 9;\n}\n\n.ui-media--video {\n  aspect-ratio: 16 / 9;\n}\n\n/* For photos taller than they are wide. Held to a readable column width so a\n   portrait shot does not stretch a full-width frame into two black margins. */\n.ui-media--portrait {\n  aspect-ratio: 3 / 4;\n  max-width: 380px;\n  margin-inline: auto;\n}\n\n/* Opt in to cropping only where the frame is decorative, not the subject. */\n.ui-media--cover > img,\n.ui-media--cover > video {\n  object-fit: cover;\n}\n\n/* Kept for callers that still ask for it explicitly; `contain` is the default. */\n.ui-media--contain > img {\n  object-fit: contain;\n}\n\n/* A light frame for artwork and diagrams that would look wrong on black. */\n.ui-media--paper {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-light);\n}\n\n.ui-media--lg {\n  border-radius: var(--radius-lg);\n}\n\n.ui-caption {\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n/* Carousel */\n.ui-carousel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  border-radius: var(--radius-md);\n}\n\n.ui-carousel:focus {\n  outline: none;\n}\n\n.ui-carousel:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 4px;\n}\n\n.ui-carousel-viewport { position: relative; overflow: hidden; touch-action: pan-y; }\n.ui-carousel-track {\n  --gap: var(--space-3);\n  display: flex;\n  gap: var(--gap);\n  transform: translateX(calc(-1 * var(--pos) * ((100% + var(--gap)) / var(--per-view))));\n  transition: transform 700ms var(--ease-standard);\n}\n.ui-carousel-track[data-instant] { transition: none; }\n.ui-carousel-slide { flex: 0 0 calc((100% + var(--gap)) / var(--per-view) - var(--gap)); min-width: 0; margin: 0; }\n.ui-carousel-slide .ui-media { width: 100%; }\n.ui-carousel-controls { display: flex; justify-content: center; align-items: center; gap: var(--space-2); }\n.ui-carousel-toggle { width: 44px; height: 44px; border: 0; border-radius: var(--radius-full); background: var(--bg-secondary); color: var(--text-primary); cursor: pointer; }\n.ui-carousel-toggle svg { width: 18px; height: 18px; }\n\n.ui-carousel-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: var(--radius-full);\n  background: rgba(255, 255, 255, 0.92);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    color var(--dur-fast) var(--ease-standard),\n    opacity var(--dur-fast) var(--ease-standard);\n}\n\n.ui-carousel-nav svg {\n  width: 17px;\n  height: 17px;\n}\n\n.ui-carousel-nav:hover {\n  color: var(--primary);\n}\n\n.ui-carousel-nav:active {\n  opacity: 0.7;\n}\n\n.ui-carousel-nav--prev {\n  left: 10px;\n}\n\n.ui-carousel-nav--next {\n  right: 10px;\n}\n\n.ui-carousel-dots {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0;\n}\n\n.ui-carousel-dot {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ui-carousel-dot::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  background: var(--border);\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    width var(--dur-fast) var(--ease-standard),\n    height var(--dur-fast) var(--ease-standard);\n}\n\n.ui-carousel-dot:hover::before {\n  background: var(--border-dark);\n}\n\n.ui-carousel-dot.is-active::before {\n  width: 10px;\n  height: 10px;\n  background: var(--primary);\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .ui-container,\n  .site-main,\n  .site-reveal,\n  .ui-spinner {\n    animation: none !important;\n  }\n\n  .ui-btn,\n  .ui-btn:active,\n  .ui-icon-btn,\n  .ui-input,\n  .ui-segmented > button,\n  .ui-carousel-nav,\n  .ui-carousel-track,\n  .ui-carousel-toggle,\n  .ui-carousel-dot::before,\n  .ui-highlight-row,\n  a.ui-card,\n  a.ui-list-row,\n  button.ui-list-row {\n    transition: none !important;\n  }\n}\n\n/* Scroll reveal */\n.ui-reveal {\n  opacity: 0;\n  transform: translateY(10px);\n  transition:\n    opacity 520ms var(--ease-standard),\n    transform 520ms var(--ease-standard);\n}\n\n.ui-reveal.is-visible {\n  opacity: 1;\n  transform: none;\n}\n\n.ui-reveal--stagger > * {\n  opacity: 0;\n  transform: translateY(10px);\n  transition:\n    opacity 520ms var(--ease-standard),\n    transform 520ms var(--ease-standard);\n  transition-delay: calc(var(--reveal-index, 0) * 90ms);\n}\n\n.ui-reveal--stagger.is-visible > * {\n  opacity: 1;\n  transform: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ui-reveal,\n  .ui-reveal.is-visible,\n  .ui-reveal--stagger > *,\n  .ui-reveal--stagger.is-visible > * {\n    opacity: 1;\n    transform: none;\n    transition: none !important;\n  }\n}\n\n/* Phones\n * One place that scales the system down for small screens: tighter gutters,\n * smaller type and padding, and image frames that never eat the whole viewport.\n */\n@media (max-width: 560px) {\n  :root {\n    --gutter: 16px;\n  }\n\n  h1 {\n    font-size: 1.4rem;\n  }\n\n  h2 {\n    font-size: 1.08rem;\n  }\n\n  .ui-page,\n  .site-page-bg {\n    padding: var(--space-3) 0 var(--space-8);\n  }\n\n  .ui-page-header p,\n  .site-page-lead {\n    font-size: .9375rem;\n  }\n\n  .ui-card {\n    padding: var(--space-4);\n    border-radius: var(--radius-md);\n  }\n\n  .ui-card--lg {\n    padding: var(--space-4);\n  }\n\n  .ui-card-header p {\n    font-size: .875rem;\n  }\n\n  .ui-hero-panel {\n    padding: var(--space-4);\n    border-radius: var(--radius-lg);\n  }\n\n  .ui-hero-panel h1 {\n    font-size: 1.45rem;\n  }\n\n  .ui-hero-panel h2 {\n    font-size: 1.2rem;\n  }\n\n  .ui-hero-panel p {\n    font-size: .9375rem;\n  }\n\n  .ui-hero-panel.ui-hero-panel--split {\n    gap: var(--space-4);\n  }\n\n  .ui-hero-panel--split > .ui-hero-media {\n    margin: calc(-1 * var(--space-4)) calc(-1 * var(--space-4)) 0;\n  }\n\n  .ui-btn--lg {\n    min-height: 44px;\n    padding: 10px 20px;\n    font-size: .9375rem;\n  }\n\n  .ui-media--portrait {\n    max-width: 280px;\n  }\n\n  .ui-list-label {\n    font-size: .875rem;\n  }\n\n  .ui-list-desc {\n    font-size: .8125rem;\n  }\n\n  .ui-caption {\n    font-size: .8125rem;\n  }\n\n  /* Inside a sentence the link flows with the text instead of padding the line. */\n  p > .research-text-link {\n    display: inline;\n    min-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
